export default "__VITE_ASSET__55363789__"